import { Box, Button, styled } from "@mui/material";

export const LogoBox = styled(Box)(({ theme }) => ({
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 2,
  width: '7.3rem',
  height: '3rem',
  marginTop: theme.spacing(1),
  marginLeft: theme.spacing(0),
  
  [theme.breakpoints.down('sm')]: {
    width: '6rem',
    height: "5vh",
    marginLeft: theme.spacing(2),
  },
}));

export const PrimaryMenu = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}));

export const MenuButton = styled(Button, {shouldForwardProp: (prop) => prop !== 'active'})(({ active }) => ({
  color: active ? '#242424' : '#000',
  borderBottom: active ? '2px solid #242424' : 'none',
  padding: 0,
  minWidth: 'auto',
  borderRadius: 0,
  fontFamily: "'Poiret One', sans-serif",
  fontSize: '0.8rem',
  fontWeight: 600,
}));

export const SubMenuBar = styled(Box)(({ theme }) => ({
  position: "absolute",
  marginTop: "4rem",
  width: "100%",
  height: "auto",
  background: "linear-gradient( rgba(31, 30, 30, 0.8) 55%)",
  // flexGrow: 1,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

export const SubMenuContainer = styled(Box)(({ theme }) => ({
  width: '90%',
  display: 'flex',
  justifyContent: "center",
  gap: "1rem",

  //mobile screen
  [theme.breakpoints.down("xxl")]: {
    gap: "0.5rem",
  },
  
  [theme.breakpoints.down("xl")]: {
    gap: "0.1rem",
  },
  
  [theme.breakpoints.down("mdlg")]: {
    gap: "0rem",
  },

  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));

export const SubMenuButton = styled(Button)(({ theme }) => ({
  display: "flex",
  margin: theme.spacing(2, 0),
  padding: theme.spacing(0, 1),
  fontSize: '0.9rem',
  fontWeight: '400',
  textTransform: 'none',
  color: "whitesmoke",
  border: "1px solid transparent",
  "&:hover": { border: "1px solid #55d6aa" },

  //mobile screen
  [theme.breakpoints.down("xxl")]: {
    fontSize: '0.9rem',
  },
  
  [theme.breakpoints.down("bp1200")]: {
    fontSize: '0.7rem',
  },
  
  [theme.breakpoints.down("lg")]: {
    fontSize: '0.7rem',
  },
  
  [theme.breakpoints.down("bp1000")]: {
    fontSize: '0.6rem',
  },

  [theme.breakpoints.down("mdlg")]: {
    fontSize: '0.53rem',
  },
}));